/**
 * Generated by "@vuepress/internal-site-data"
 */
export const siteData = {
  "title": "V-Calendar",
  "description": "An elegant calendar and datepicker plugin for Vuejs.",
  "base": "/v-calendar/",
  "pages": [
    {
      "title": "Home",
      "frontmatter": {
        "home": true,
        "heroImage": "/hero.png",
        "actionText": "Get Started →",
        "actionLink": "/guide/",
        "footer": "MIT Licensed | Copyright © 2017-Present Nathan Reyes",
        "pageClass": "homepage"
      },
      "regularPath": "/",
      "relativePath": "README.md",
      "key": "v-9918d412",
      "path": "/"
    },
    {
      "title": "Calendar",
      "frontmatter": {
        "title": "Calendar",
        "sidebarDepth": 2
      },
      "regularPath": "/api/calendar.html",
      "relativePath": "api/calendar.md",
      "key": "v-05d4be8a",
      "path": "/api/calendar.html",
      "headers": [
        {
          "level": 2,
          "title": "Props",
          "slug": "props"
        },
        {
          "level": 3,
          "title": "rows",
          "slug": "rows"
        },
        {
          "level": 3,
          "title": "columns",
          "slug": "columns"
        },
        {
          "level": 3,
          "title": "title-position",
          "slug": "title-position"
        },
        {
          "level": 3,
          "title": "nav-visibility",
          "slug": "nav-visibility"
        },
        {
          "level": 3,
          "title": "is-expanded",
          "slug": "is-expanded"
        },
        {
          "level": 3,
          "title": "transition",
          "slug": "transition"
        },
        {
          "level": 3,
          "title": "step",
          "slug": "step"
        },
        {
          "level": 3,
          "title": "from-page",
          "slug": "from-page"
        },
        {
          "level": 3,
          "title": "from-date",
          "slug": "from-date"
        },
        {
          "level": 3,
          "title": "to-page",
          "slug": "to-page"
        },
        {
          "level": 3,
          "title": "to-date",
          "slug": "to-date"
        },
        {
          "level": 3,
          "title": "min-page",
          "slug": "min-page"
        },
        {
          "level": 3,
          "title": "min-date",
          "slug": "min-date"
        },
        {
          "level": 3,
          "title": "max-page",
          "slug": "max-page"
        },
        {
          "level": 3,
          "title": "max-date",
          "slug": "max-date"
        },
        {
          "level": 3,
          "title": "attributes",
          "slug": "attributes"
        },
        {
          "level": 3,
          "title": "masks",
          "slug": "masks"
        },
        {
          "level": 3,
          "title": "color",
          "slug": "color"
        },
        {
          "level": 3,
          "title": "is-dark",
          "slug": "is-dark"
        },
        {
          "level": 3,
          "title": "theme",
          "slug": "theme"
        },
        {
          "level": 3,
          "title": "first-day-of-week",
          "slug": "first-day-of-week"
        },
        {
          "level": 3,
          "title": "locale",
          "slug": "locale"
        },
        {
          "level": 3,
          "title": "disable-page-swipe",
          "slug": "disable-page-swipe"
        },
        {
          "level": 2,
          "title": "Events",
          "slug": "events"
        },
        {
          "level": 3,
          "title": "update:frompage",
          "slug": "update-frompage"
        },
        {
          "level": 3,
          "title": "update:topage",
          "slug": "update-topage"
        },
        {
          "level": 3,
          "title": "dayclick",
          "slug": "dayclick"
        },
        {
          "level": 3,
          "title": "daymouseenter",
          "slug": "daymouseenter"
        },
        {
          "level": 3,
          "title": "daymouseover",
          "slug": "daymouseover"
        },
        {
          "level": 3,
          "title": "daymouseleave",
          "slug": "daymouseleave"
        },
        {
          "level": 2,
          "title": "Methods",
          "slug": "methods"
        },
        {
          "level": 3,
          "title": "showPageRange({ from, to })",
          "slug": "showpagerange-from-to"
        },
        {
          "level": 2,
          "title": "Scoped Slots",
          "slug": "scoped-slots"
        },
        {
          "level": 3,
          "title": "header",
          "slug": "header"
        },
        {
          "level": 3,
          "title": "header-title",
          "slug": "header-title"
        },
        {
          "level": 3,
          "title": "header-left-button",
          "slug": "header-left-button"
        },
        {
          "level": 3,
          "title": "header-right-button",
          "slug": "header-right-button"
        },
        {
          "level": 3,
          "title": "day-content",
          "slug": "day-content"
        },
        {
          "level": 3,
          "title": "day-popover",
          "slug": "day-popover"
        }
      ]
    },
    {
      "title": "Date Patterns",
      "frontmatter": {
        "title": "Date Patterns",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/api/date-patterns.html",
      "relativePath": "api/date-patterns.md",
      "key": "v-9e116638",
      "path": "/api/date-patterns.html",
      "headers": [
        {
          "level": 2,
          "title": "Date Patterns",
          "slug": "date-patterns"
        },
        {
          "level": 3,
          "title": "days",
          "slug": "days"
        },
        {
          "level": 3,
          "title": "weekdays",
          "slug": "weekdays"
        },
        {
          "level": 3,
          "title": "ordinalWeekdays",
          "slug": "ordinalweekdays"
        },
        {
          "level": 3,
          "title": "weeks",
          "slug": "weeks"
        },
        {
          "level": 3,
          "title": "months",
          "slug": "months"
        },
        {
          "level": 3,
          "title": "years",
          "slug": "years"
        },
        {
          "level": 3,
          "title": "dailyInterval",
          "slug": "dailyinterval"
        },
        {
          "level": 3,
          "title": "weeklyInterval",
          "slug": "weeklyinterval"
        },
        {
          "level": 3,
          "title": "monthlyInterval",
          "slug": "monthlyinterval"
        },
        {
          "level": 3,
          "title": "yearlyInterval",
          "slug": "yearlyinterval"
        }
      ]
    },
    {
      "title": "Overview",
      "frontmatter": {},
      "regularPath": "/api/",
      "relativePath": "api/README.md",
      "key": "v-300724e1",
      "path": "/api/"
    },
    {
      "title": "Day Object",
      "frontmatter": {
        "title": "Day Object",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/api/day-object.html",
      "relativePath": "api/day-object.md",
      "key": "v-1b062c26",
      "path": "/api/day-object.html",
      "headers": [
        {
          "level": 2,
          "title": "Properties",
          "slug": "properties"
        },
        {
          "level": 3,
          "title": "day",
          "slug": "day"
        },
        {
          "level": 3,
          "title": "dayFromEnd",
          "slug": "dayfromend"
        },
        {
          "level": 3,
          "title": "weekday",
          "slug": "weekday"
        },
        {
          "level": 3,
          "title": "weekdayOrdinal",
          "slug": "weekdayordinal"
        },
        {
          "level": 3,
          "title": "weekdayOrdinalFromEnd",
          "slug": "weekdayordinalfromend"
        },
        {
          "level": 3,
          "title": "week",
          "slug": "week"
        },
        {
          "level": 3,
          "title": "weekFromEnd",
          "slug": "weekfromend"
        },
        {
          "level": 3,
          "title": "month",
          "slug": "month"
        },
        {
          "level": 3,
          "title": "year",
          "slug": "year"
        },
        {
          "level": 3,
          "title": "date",
          "slug": "date"
        },
        {
          "level": 3,
          "title": "dateTime",
          "slug": "datetime"
        },
        {
          "level": 3,
          "title": "inMonth",
          "slug": "inmonth"
        },
        {
          "level": 3,
          "title": "inPrevMonth",
          "slug": "inprevmonth"
        },
        {
          "level": 3,
          "title": "inNextMonth",
          "slug": "innextmonth"
        },
        {
          "level": 3,
          "title": "attributes",
          "slug": "attributes"
        },
        {
          "level": 3,
          "title": "attributesMap",
          "slug": "attributesmap"
        },
        {
          "level": 3,
          "title": "event",
          "slug": "event"
        }
      ]
    },
    {
      "title": "Attribute",
      "frontmatter": {
        "title": "Attribute",
        "sidebarDepth": 2
      },
      "regularPath": "/api/attribute.html",
      "relativePath": "api/attribute.md",
      "key": "v-4a8d8624",
      "path": "/api/attribute.html",
      "headers": [
        {
          "level": 2,
          "title": "Properties",
          "slug": "properties"
        },
        {
          "level": 3,
          "title": "key",
          "slug": "key"
        },
        {
          "level": 3,
          "title": "highlight",
          "slug": "highlight"
        },
        {
          "level": 3,
          "title": "dot",
          "slug": "dot"
        },
        {
          "level": 3,
          "title": "bar",
          "slug": "bar"
        },
        {
          "level": 3,
          "title": "popover",
          "slug": "popover"
        },
        {
          "level": 3,
          "title": "contentClass",
          "slug": "contentclass"
        },
        {
          "level": 3,
          "title": "contentStyle",
          "slug": "contentstyle"
        },
        {
          "level": 3,
          "title": "dates",
          "slug": "dates"
        },
        {
          "level": 3,
          "title": "excludeDates",
          "slug": "excludedates"
        },
        {
          "level": 3,
          "title": "customObject",
          "slug": "customobject"
        },
        {
          "level": 3,
          "title": "order",
          "slug": "order"
        },
        {
          "level": 2,
          "title": "Highlight Object",
          "slug": "highlight-object"
        },
        {
          "level": 3,
          "title": "animated",
          "slug": "animated"
        },
        {
          "level": 3,
          "title": "height",
          "slug": "height"
        },
        {
          "level": 3,
          "title": "backgroundColor",
          "slug": "backgroundcolor"
        },
        {
          "level": 3,
          "title": "borderColor",
          "slug": "bordercolor"
        },
        {
          "level": 3,
          "title": "borderWidth",
          "slug": "borderwidth"
        },
        {
          "level": 3,
          "title": "borderStyle",
          "slug": "borderstyle"
        },
        {
          "level": 3,
          "title": "borderRadius",
          "slug": "borderradius"
        },
        {
          "level": 3,
          "title": "opacity",
          "slug": "opacity"
        },
        {
          "level": 2,
          "title": "Dot Object",
          "slug": "dot-object"
        },
        {
          "level": 3,
          "title": "diameter",
          "slug": "diameter"
        },
        {
          "level": 3,
          "title": "backgroundColor",
          "slug": "backgroundcolor-2"
        },
        {
          "level": 3,
          "title": "borderColor",
          "slug": "bordercolor-2"
        },
        {
          "level": 3,
          "title": "borderWidth",
          "slug": "borderwidth-2"
        },
        {
          "level": 3,
          "title": "borderStyle",
          "slug": "borderstyle-2"
        },
        {
          "level": 3,
          "title": "borderRadius",
          "slug": "borderradius-2"
        },
        {
          "level": 3,
          "title": "opacity",
          "slug": "opacity-2"
        },
        {
          "level": 2,
          "title": "Bar Object",
          "slug": "bar-object"
        },
        {
          "level": 3,
          "title": "height",
          "slug": "height-2"
        },
        {
          "level": 3,
          "title": "backgroundColor",
          "slug": "backgroundcolor-3"
        },
        {
          "level": 3,
          "title": "borderColor",
          "slug": "bordercolor-3"
        },
        {
          "level": 3,
          "title": "borderWidth",
          "slug": "borderwidth-3"
        },
        {
          "level": 3,
          "title": "backgroundColor",
          "slug": "backgroundcolor-4"
        },
        {
          "level": 3,
          "title": "opacity",
          "slug": "opacity-3"
        },
        {
          "level": 2,
          "title": "Popover Object",
          "slug": "popover-object"
        },
        {
          "level": 3,
          "title": "label",
          "slug": "label"
        },
        {
          "level": 3,
          "title": "labelStyle",
          "slug": "labelstyle"
        },
        {
          "level": 3,
          "title": "hideIndicator",
          "slug": "hideindicator"
        },
        {
          "level": 3,
          "title": "slot",
          "slug": "slot"
        },
        {
          "level": 3,
          "title": "visibility",
          "slug": "visibility"
        },
        {
          "level": 3,
          "title": "isInteractive",
          "slug": "isinteractive"
        },
        {
          "level": 2,
          "title": "Content Style Object",
          "slug": "content-style-object"
        },
        {
          "level": 2,
          "title": "Content Hover Style (Deprecated)",
          "slug": "content-hover-style-deprecated"
        }
      ]
    },
    {
      "title": "Date Picker",
      "frontmatter": {
        "title": "Date Picker",
        "sidebarDepth": 2
      },
      "regularPath": "/api/datepicker.html",
      "relativePath": "api/datepicker.md",
      "key": "v-32837fce",
      "path": "/api/datepicker.html",
      "headers": [
        {
          "level": 2,
          "title": "Props",
          "slug": "props"
        },
        {
          "level": 3,
          "title": "mode",
          "slug": "mode"
        },
        {
          "level": 3,
          "title": "value",
          "slug": "value"
        },
        {
          "level": 3,
          "title": "is-required",
          "slug": "is-required"
        },
        {
          "level": 3,
          "title": "is-inline",
          "slug": "is-inline"
        },
        {
          "level": 3,
          "title": "min-date",
          "slug": "min-date"
        },
        {
          "level": 3,
          "title": "max-date",
          "slug": "max-date"
        },
        {
          "level": 3,
          "title": "disabled-dates",
          "slug": "disabled-dates"
        },
        {
          "level": 3,
          "title": "available-dates",
          "slug": "available-dates"
        },
        {
          "level": 3,
          "title": "input-props",
          "slug": "input-props"
        },
        {
          "level": 3,
          "title": "update-on-input",
          "slug": "update-on-input"
        },
        {
          "level": 3,
          "title": "input-debounce",
          "slug": "input-debounce"
        },
        {
          "level": 3,
          "title": "drag-attribute",
          "slug": "drag-attribute"
        },
        {
          "level": 3,
          "title": "select-attribute",
          "slug": "select-attribute"
        },
        {
          "level": 3,
          "title": "popover",
          "slug": "popover"
        },
        {
          "level": 2,
          "title": "Events",
          "slug": "events"
        },
        {
          "level": 3,
          "title": "input",
          "slug": "input"
        },
        {
          "level": 3,
          "title": "drag",
          "slug": "drag"
        },
        {
          "level": 2,
          "title": "Scoped Slots",
          "slug": "scoped-slots"
        },
        {
          "level": 3,
          "title": "`default`",
          "slug": "default"
        }
      ]
    },
    {
      "title": "Defaults",
      "frontmatter": {
        "title": "Defaults",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/api/defaults.html",
      "relativePath": "api/defaults.md",
      "key": "v-132b1162",
      "path": "/api/defaults.html",
      "headers": [
        {
          "level": 2,
          "title": "Properties",
          "slug": "properties"
        },
        {
          "level": 3,
          "title": "componentPrefix",
          "slug": "componentprefix"
        },
        {
          "level": 3,
          "title": "titlePosition",
          "slug": "titleposition"
        },
        {
          "level": 3,
          "title": "navVisibility",
          "slug": "navvisibility"
        },
        {
          "level": 3,
          "title": "transition",
          "slug": "transition"
        },
        {
          "level": 3,
          "title": "masks",
          "slug": "masks"
        },
        {
          "level": 3,
          "title": "screens",
          "slug": "screens"
        },
        {
          "level": 3,
          "title": "theme",
          "slug": "theme"
        },
        {
          "level": 3,
          "title": "locale",
          "slug": "locale"
        },
        {
          "level": 3,
          "title": "locales",
          "slug": "locales"
        },
        {
          "level": 3,
          "title": "datePicker",
          "slug": "datepicker"
        },
        {
          "level": 3,
          "title": "datePicker.updateOnInput",
          "slug": "datepicker-updateoninput"
        },
        {
          "level": 3,
          "title": "datePicker.inputDebounce",
          "slug": "datepicker-inputdebounce"
        },
        {
          "level": 3,
          "title": "datePicker.popover",
          "slug": "datepicker-popover"
        },
        {
          "level": 3,
          "title": "datePicker.popover.visibility",
          "slug": "datepicker-popover-visibility"
        },
        {
          "level": 3,
          "title": "datePicker.popover.keepVisibleOnInput",
          "slug": "datepicker-popover-keepvisibleoninput"
        },
        {
          "level": 3,
          "title": "datePicker.popover.placement",
          "slug": "datepicker-popover-placement"
        },
        {
          "level": 3,
          "title": "touch",
          "slug": "touch"
        },
        {
          "level": 3,
          "title": "touch.maxSwipeTime",
          "slug": "touch-maxswipetime"
        },
        {
          "level": 3,
          "title": "touch.minHorizontalSwipeDistance",
          "slug": "touch-minhorizontalswipedistance"
        },
        {
          "level": 3,
          "title": "touch.maxVerticalSwipeDistance",
          "slug": "touch-maxverticalswipedistance"
        }
      ]
    },
    {
      "title": "Page Object",
      "frontmatter": {
        "title": "Page Object",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/api/page-object.html",
      "relativePath": "api/page-object.md",
      "key": "v-9ed191f8",
      "path": "/api/page-object.html",
      "headers": [
        {
          "level": 2,
          "title": "position",
          "slug": "position"
        },
        {
          "level": 2,
          "title": "month",
          "slug": "month"
        },
        {
          "level": 2,
          "title": "year",
          "slug": "year"
        },
        {
          "level": 2,
          "title": "monthLabel",
          "slug": "monthlabel"
        },
        {
          "level": 2,
          "title": "shortMonthLabel",
          "slug": "shortmonthlabel"
        },
        {
          "level": 2,
          "title": "yearLabel",
          "slug": "yearlabel"
        },
        {
          "level": 2,
          "title": "shortYearLabel",
          "slug": "shortyearlabel"
        },
        {
          "level": 2,
          "title": "monthComps",
          "slug": "monthcomps"
        },
        {
          "level": 2,
          "title": "prevMonthComps",
          "slug": "prevmonthcomps"
        },
        {
          "level": 2,
          "title": "nextMonthComps",
          "slug": "nextmonthcomps"
        },
        {
          "level": 2,
          "title": "canMove(Object) => Boolean",
          "slug": "canmove-object-boolean"
        },
        {
          "level": 2,
          "title": "move(Object)",
          "slug": "move-object"
        },
        {
          "level": 2,
          "title": "moveThisMonth()",
          "slug": "movethismonth"
        },
        {
          "level": 2,
          "title": "movePrevMonth()",
          "slug": "moveprevmonth"
        },
        {
          "level": 2,
          "title": "moveNextMonth()",
          "slug": "movenextmonth"
        }
      ]
    },
    {
      "title": "Theme Styles",
      "frontmatter": {
        "title": "Theme Styles",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/api/theme-styles.html",
      "relativePath": "api/theme-styles.md",
      "key": "v-7f66da8c",
      "path": "/api/theme-styles.html",
      "headers": [
        {
          "level": 2,
          "title": "wrapper",
          "slug": "wrapper"
        },
        {
          "level": 2,
          "title": "verticalDivider",
          "slug": "verticaldivider"
        },
        {
          "level": 2,
          "title": "horizontalDivider",
          "slug": "horizontaldivider"
        },
        {
          "level": 2,
          "title": "header",
          "slug": "header"
        },
        {
          "level": 2,
          "title": "headerTitle",
          "slug": "headertitle"
        },
        {
          "level": 2,
          "title": "headerArrows",
          "slug": "headerarrows"
        },
        {
          "level": 2,
          "title": "headerHorizontalDivider",
          "slug": "headerhorizontaldivider"
        },
        {
          "level": 2,
          "title": "weekdays",
          "slug": "weekdays"
        },
        {
          "level": 2,
          "title": "weekdaysHorizontalDivider",
          "slug": "weekdayshorizontaldivider"
        },
        {
          "level": 2,
          "title": "weeks",
          "slug": "weeks"
        },
        {
          "level": 2,
          "title": "dayCell",
          "slug": "daycell"
        },
        {
          "level": 2,
          "title": "dayContent",
          "slug": "daycontent"
        },
        {
          "level": 2,
          "title": "dayPopoverContent",
          "slug": "daypopovercontent"
        },
        {
          "level": 2,
          "title": "dots",
          "slug": "dots"
        },
        {
          "level": 2,
          "title": "bars",
          "slug": "bars"
        },
        {
          "level": 2,
          "title": "navHeader",
          "slug": "navheader"
        },
        {
          "level": 2,
          "title": "navHeaderArrows",
          "slug": "navheaderarrows"
        },
        {
          "level": 2,
          "title": "navHeaderTitle",
          "slug": "navheadertitle"
        },
        {
          "level": 2,
          "title": "navMonthCell",
          "slug": "navmonthcell"
        },
        {
          "level": 2,
          "title": "navYearCell",
          "slug": "navyearcell"
        }
      ]
    },
    {
      "title": "v0.1",
      "frontmatter": {
        "title": "v0.1"
      },
      "regularPath": "/changelog/v0.1.html",
      "relativePath": "changelog/v0.1.md",
      "key": "v-f5ffb980",
      "path": "/changelog/v0.1.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.0.4",
          "slug": "v0-0-4"
        },
        {
          "level": 2,
          "title": "v0.0.5",
          "slug": "v0-0-5"
        },
        {
          "level": 2,
          "title": "v0.0.6",
          "slug": "v0-0-6"
        },
        {
          "level": 2,
          "title": "v0.0.7",
          "slug": "v0-0-7"
        },
        {
          "level": 2,
          "title": "v0.0.8",
          "slug": "v0-0-8"
        },
        {
          "level": 2,
          "title": "v0.0.9",
          "slug": "v0-0-9"
        },
        {
          "level": 2,
          "title": "v0.1.0",
          "slug": "v0-1-0"
        },
        {
          "level": 2,
          "title": "v0.1.1",
          "slug": "v0-1-1"
        }
      ]
    },
    {
      "title": "v0.2",
      "frontmatter": {
        "title": "v0.2"
      },
      "regularPath": "/changelog/v0.2.html",
      "relativePath": "changelog/v0.2.md",
      "key": "v-fa92ea84",
      "path": "/changelog/v0.2.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.2.0",
          "slug": "v0-2-0"
        },
        {
          "level": 2,
          "title": "v0.2.1",
          "slug": "v0-2-1"
        },
        {
          "level": 2,
          "title": "v0.2.2",
          "slug": "v0-2-2"
        }
      ]
    },
    {
      "title": "v0.3",
      "frontmatter": {
        "title": "v0.3"
      },
      "regularPath": "/changelog/v0.3.html",
      "relativePath": "changelog/v0.3.md",
      "key": "v-ff261b88",
      "path": "/changelog/v0.3.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.3.0",
          "slug": "v0-3-0"
        },
        {
          "level": 2,
          "title": "v0.3.1",
          "slug": "v0-3-1"
        },
        {
          "level": 2,
          "title": "v0.3.2",
          "slug": "v0-3-2"
        },
        {
          "level": 2,
          "title": "v0.3.3",
          "slug": "v0-3-3"
        }
      ]
    },
    {
      "title": "v0.4",
      "frontmatter": {
        "title": "v0.4"
      },
      "regularPath": "/changelog/v0.4.html",
      "relativePath": "changelog/v0.4.md",
      "key": "v-7e2359ba",
      "path": "/changelog/v0.4.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.4.0",
          "slug": "v0-4-0"
        },
        {
          "level": 2,
          "title": "v0.4.1",
          "slug": "v0-4-1"
        },
        {
          "level": 2,
          "title": "v0.4.2",
          "slug": "v0-4-2"
        },
        {
          "level": 2,
          "title": "v0.4.3",
          "slug": "v0-4-3"
        }
      ]
    },
    {
      "title": "v0.6",
      "frontmatter": {
        "title": "v0.6"
      },
      "regularPath": "/changelog/v0.6.html",
      "relativePath": "changelog/v0.6.md",
      "key": "v-799028b6",
      "path": "/changelog/v0.6.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.6.0",
          "slug": "v0-6-0"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements"
        },
        {
          "level": 2,
          "title": "v0.6.1",
          "slug": "v0-6-1"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-2"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-2"
        },
        {
          "level": 2,
          "title": "v0.6.2",
          "slug": "v0-6-2"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-3"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-3"
        },
        {
          "level": 2,
          "title": "v0.6.3",
          "slug": "v0-6-3"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-4"
        }
      ]
    },
    {
      "title": "v0.5",
      "frontmatter": {
        "title": "v0.5"
      },
      "regularPath": "/changelog/v0.5.html",
      "relativePath": "changelog/v0.5.md",
      "key": "v-7bd9c138",
      "path": "/changelog/v0.5.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.5.0",
          "slug": "v0-5-0"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements"
        },
        {
          "level": 2,
          "title": "v0.5.1",
          "slug": "v0-5-1"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-2"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-2"
        },
        {
          "level": 2,
          "title": "v0.5.2",
          "slug": "v0-5-2"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-3"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-3"
        },
        {
          "level": 2,
          "title": "v0.5.3",
          "slug": "v0-5-3"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-4"
        },
        {
          "level": 2,
          "title": "v0.5.4",
          "slug": "v0-5-4"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-5"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-4"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-5"
        },
        {
          "level": 2,
          "title": "v0.5.5",
          "slug": "v0-5-5"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-6"
        }
      ]
    },
    {
      "title": "v0.7",
      "frontmatter": {
        "title": "v0.7"
      },
      "regularPath": "/changelog/v0.7.html",
      "relativePath": "changelog/v0.7.md",
      "key": "v-77469034",
      "path": "/changelog/v0.7.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.7.0",
          "slug": "v0-7-0"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements"
        },
        {
          "level": 2,
          "title": "v0.7.1",
          "slug": "v0-7-1"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-2"
        },
        {
          "level": 2,
          "title": "v0.7.2",
          "slug": "v0-7-2"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-3"
        },
        {
          "level": 2,
          "title": "v0.7.3",
          "slug": "v0-7-3"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-4"
        },
        {
          "level": 2,
          "title": "v0.7.4",
          "slug": "v0-7-4"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-5"
        },
        {
          "level": 2,
          "title": "v0.7.5",
          "slug": "v0-7-5"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-6"
        }
      ]
    },
    {
      "title": "v0.8",
      "frontmatter": {
        "title": "v0.8"
      },
      "regularPath": "/changelog/v0.8.html",
      "relativePath": "changelog/v0.8.md",
      "key": "v-74fcf7b2",
      "path": "/changelog/v0.8.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.8.0",
          "slug": "v0-8-0"
        },
        {
          "level": 3,
          "title": "Date Picker Day Popover",
          "slug": "date-picker-day-popover"
        },
        {
          "level": 3,
          "title": "Attribute Functions",
          "slug": "attribute-functions"
        }
      ]
    },
    {
      "title": "v0.9",
      "frontmatter": {
        "title": "v0.9"
      },
      "regularPath": "/changelog/v0.9.html",
      "relativePath": "changelog/v0.9.md",
      "key": "v-72b35f30",
      "path": "/changelog/v0.9.html",
      "headers": [
        {
          "level": 2,
          "title": "v0.9.0",
          "slug": "v0-9-0"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements"
        },
        {
          "level": 2,
          "title": "v0.9.1",
          "slug": "v0-9-1"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-2"
        },
        {
          "level": 2,
          "title": "v0.9.2",
          "slug": "v0-9-2"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-3"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-2"
        },
        {
          "level": 2,
          "title": "v0.9.3",
          "slug": "v0-9-3"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-4"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-3"
        },
        {
          "level": 3,
          "title": "defaults",
          "slug": "defaults-2"
        },
        {
          "level": 2,
          "title": "v0.9.4",
          "slug": "v0-9-4"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-5"
        },
        {
          "level": 2,
          "title": "v0.9.5",
          "slug": "v0-9-5"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-4"
        },
        {
          "level": 2,
          "title": "v0.9.6",
          "slug": "v0-9-6"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-6"
        },
        {
          "level": 2,
          "title": "v0.9.7",
          "slug": "v0-9-7"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-7"
        }
      ]
    },
    {
      "title": "Issue 290",
      "frontmatter": {},
      "regularPath": "/github/290.html",
      "relativePath": "github/290.md",
      "key": "v-5f046bb6",
      "path": "/github/290.html",
      "headers": [
        {
          "level": 2,
          "title": "Issue 290",
          "slug": "issue-290"
        }
      ]
    },
    {
      "title": "Issue 280",
      "frontmatter": {},
      "regularPath": "/github/280.html",
      "relativePath": "github/280.md",
      "key": "v-1d853af4",
      "path": "/github/280.html",
      "headers": [
        {
          "level": 2,
          "title": "Issue 280",
          "slug": "issue-280"
        }
      ]
    },
    {
      "title": "Issue 302",
      "frontmatter": {},
      "regularPath": "/github/302.html",
      "relativePath": "github/302.md",
      "key": "v-5ac00b44",
      "path": "/github/302.html",
      "headers": [
        {
          "level": 2,
          "title": "Issue 302",
          "slug": "issue-302"
        }
      ]
    },
    {
      "title": "Github Issues",
      "frontmatter": {
        "title": "Github Issues",
        "layout": "TestLayout"
      },
      "regularPath": "/github/",
      "relativePath": "github/README.md",
      "key": "v-d1f16072",
      "path": "/github/"
    },
    {
      "title": "Theming",
      "frontmatter": {
        "title": "Theming",
        "sidebarDepth": 2
      },
      "regularPath": "/guide/theming-guide.html",
      "relativePath": "guide/theming-guide.md",
      "key": "v-45396244",
      "path": "/guide/theming-guide.html"
    },
    {
      "title": "Working With Dates",
      "frontmatter": {},
      "regularPath": "/guide/working-with-dates.html",
      "relativePath": "guide/working-with-dates.md",
      "key": "v-682db816",
      "path": "/guide/working-with-dates.html",
      "headers": [
        {
          "level": 2,
          "title": "Working With Dates",
          "slug": "working-with-dates"
        },
        {
          "level": 3,
          "title": "Explicit vs Implicit",
          "slug": "explicit-vs-implicit"
        },
        {
          "level": 3,
          "title": "Simple Dates",
          "slug": "simple-dates"
        },
        {
          "level": 3,
          "title": "Date Ranges",
          "slug": "date-ranges"
        },
        {
          "level": 3,
          "title": "Date Patterns",
          "slug": "date-patterns"
        }
      ]
    },
    {
      "title": "My Demos",
      "frontmatter": {
        "title": "My Demos",
        "heroImage": "/hero.png",
        "actionLink": "/mydemos/"
      },
      "regularPath": "/mydemos/",
      "relativePath": "mydemos/README.md",
      "key": "v-f93619e6",
      "path": "/mydemos/"
    },
    {
      "title": "Showcase",
      "frontmatter": {
        "title": "Showcase",
        "sidebarDepth": 2
      },
      "regularPath": "/showcase/",
      "relativePath": "showcase/README.md",
      "key": "v-67fa1cf2",
      "path": "/showcase/"
    },
    {
      "title": "Github Issues",
      "frontmatter": {
        "title": "Github Issues",
        "sidebarDepth": 2,
        "pageClass": "docs-page"
      },
      "regularPath": "/showcase/github.html",
      "relativePath": "showcase/github.md",
      "key": "v-707303b8",
      "path": "/showcase/github.html",
      "headers": [
        {
          "level": 2,
          "title": "Issue #140",
          "slug": "issue-140"
        }
      ]
    },
    {
      "title": "Tests",
      "frontmatter": {
        "title": "Tests",
        "layout": "TestLayout"
      },
      "regularPath": "/tests/",
      "relativePath": "tests/README.md",
      "key": "v-28b1145a",
      "path": "/tests/"
    },
    {
      "title": "v1.0",
      "frontmatter": {
        "title": "v1.0"
      },
      "regularPath": "/changelog/v1.0.html",
      "relativePath": "changelog/v1.0.md",
      "key": "v-1df78880",
      "path": "/changelog/v1.0.html",
      "headers": [
        {
          "level": 2,
          "title": "v1.0.0-beta.0",
          "slug": "v1-0-0-beta-0"
        },
        {
          "level": 3,
          "title": "Quick Update",
          "slug": "quick-update"
        },
        {
          "level": 3,
          "title": "Responsive Layouts",
          "slug": "responsive-layouts"
        },
        {
          "level": 3,
          "title": "i18n Improvements",
          "slug": "i18n-improvements"
        },
        {
          "level": 3,
          "title": "Modern Design",
          "slug": "modern-design"
        },
        {
          "level": 3,
          "title": "Theming & Dark Mode",
          "slug": "theming-dark-mode"
        },
        {
          "level": 3,
          "title": "Attributes API",
          "slug": "attributes-api"
        },
        {
          "level": 3,
          "title": "Datepicker Improvements",
          "slug": "datepicker-improvements"
        },
        {
          "level": 3,
          "title": "Popper.js Integration",
          "slug": "popper-js-integration"
        },
        {
          "level": 3,
          "title": "Defaults Restructuring",
          "slug": "defaults-restructuring"
        },
        {
          "level": 3,
          "title": "Modifications to Props & Events",
          "slug": "modifications-to-props-events"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.1",
          "slug": "v1-0-0-beta-1"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-2"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.2",
          "slug": "v1-0-0-beta-2"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-3"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.4",
          "slug": "v1-0-0-beta-4"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-4"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.5",
          "slug": "v1-0-0-beta-5"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-5"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.7, beta.8",
          "slug": "v1-0-0-beta-7-beta-8"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-6"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-2"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.9",
          "slug": "v1-0-0-beta-9"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-7"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-3"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.10",
          "slug": "v1-0-0-beta-10"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-8"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-4"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.11",
          "slug": "v1-0-0-beta-11"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-9"
        },
        {
          "level": 3,
          "title": "Improvements",
          "slug": "improvements-5"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.12",
          "slug": "v1-0-0-beta-12"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-10"
        },
        {
          "level": 2,
          "title": "v1.0.0-beta.13",
          "slug": "v1-0-0-beta-13"
        },
        {
          "level": 3,
          "title": "Bug Fixes",
          "slug": "bug-fixes-11"
        }
      ]
    },
    {
      "title": "Working With Data",
      "frontmatter": {},
      "regularPath": "/guide/data.html",
      "relativePath": "guide/data.md",
      "key": "v-f02f6994",
      "path": "/guide/data.html",
      "headers": [
        {
          "level": 2,
          "title": "Step 1: Converting Data to Attributes",
          "slug": "step-1-converting-data-to-attributes"
        },
        {
          "level": 2,
          "title": "Step 2: Handling Events",
          "slug": "step-2-handling-events"
        },
        {
          "level": 2,
          "title": "DateInfo & Attributes Lifecycle",
          "slug": "dateinfo-attributes-lifecycle"
        }
      ]
    },
    {
      "title": "Date Picker",
      "frontmatter": {
        "title": "Date Picker",
        "sidebarDepth": 2
      },
      "regularPath": "/guide/datepicker.html",
      "relativePath": "guide/datepicker.md",
      "key": "v-3efac25c",
      "path": "/guide/datepicker.html",
      "headers": [
        {
          "level": 2,
          "title": "Display Options",
          "slug": "display-options"
        },
        {
          "level": 3,
          "title": "Popover",
          "slug": "popover"
        },
        {
          "level": 3,
          "title": "Custom Slot",
          "slug": "custom-slot"
        },
        {
          "level": 3,
          "title": "Inline",
          "slug": "inline"
        },
        {
          "level": 2,
          "title": "Selection Modes",
          "slug": "selection-modes"
        },
        {
          "level": 3,
          "title": "Single Date",
          "slug": "single-date"
        },
        {
          "level": 3,
          "title": "Multiple Dates",
          "slug": "multiple-dates"
        },
        {
          "level": 3,
          "title": "Date Range",
          "slug": "date-range"
        },
        {
          "level": 2,
          "title": "Format & Parse Dates",
          "slug": "format-parse-dates"
        },
        {
          "level": 2,
          "title": "Disable Dates",
          "slug": "disable-dates"
        },
        {
          "level": 2,
          "title": "Require Selected Date",
          "slug": "require-selected-date"
        },
        {
          "level": 2,
          "title": "Customize Input Element",
          "slug": "customize-input-element"
        },
        {
          "level": 3,
          "title": "Set input-props",
          "slug": "set-input-props"
        },
        {
          "level": 3,
          "title": "Use Custom Slot",
          "slug": "use-custom-slot"
        },
        {
          "level": 3,
          "title": "Disable Update On Input",
          "slug": "disable-update-on-input"
        },
        {
          "level": 3,
          "title": "Set Input Debounce",
          "slug": "set-input-debounce"
        },
        {
          "level": 2,
          "title": "Customize Attributes",
          "slug": "customize-attributes"
        },
        {
          "level": 3,
          "title": "Selection Popover",
          "slug": "selection-popover"
        }
      ]
    },
    {
      "title": "Attributes",
      "frontmatter": {
        "title": "Attributes",
        "sidebarDepth": 2
      },
      "regularPath": "/guide/attributes.html",
      "relativePath": "guide/attributes.md",
      "key": "v-589704dc",
      "path": "/guide/attributes.html",
      "headers": [
        {
          "level": 2,
          "title": "Quick Guide",
          "slug": "quick-guide"
        },
        {
          "level": 2,
          "title": "Attribute Types",
          "slug": "attribute-types"
        },
        {
          "level": 3,
          "title": "Using customData",
          "slug": "using-customdata"
        },
        {
          "level": 3,
          "title": "Using order",
          "slug": "using-order"
        },
        {
          "level": 2,
          "title": "Highlights",
          "slug": "highlights"
        },
        {
          "level": 2,
          "title": "Dots",
          "slug": "dots"
        },
        {
          "level": 2,
          "title": "Bars",
          "slug": "bars"
        },
        {
          "level": 2,
          "title": "Popovers",
          "slug": "popovers"
        },
        {
          "level": 3,
          "title": "1. Labels",
          "slug": "_1-labels"
        },
        {
          "level": 3,
          "title": "2. Scoped Slot",
          "slug": "_2-scoped-slot"
        }
      ]
    },
    {
      "title": "V-Calendar",
      "frontmatter": {
        "title": "V-Calendar",
        "sidebarDepth": 2
      },
      "regularPath": "/guide/",
      "relativePath": "guide/README.md",
      "key": "v-242728dd",
      "path": "/guide/",
      "headers": [
        {
          "level": 2,
          "title": "Component",
          "slug": "component"
        },
        {
          "level": 3,
          "title": "Colors & Dark Mode",
          "slug": "colors-dark-mode"
        },
        {
          "level": 2,
          "title": "Layouts",
          "slug": "layouts"
        },
        {
          "level": 3,
          "title": "Full Width",
          "slug": "full-width"
        },
        {
          "level": 3,
          "title": "Title Positioning",
          "slug": "title-positioning"
        },
        {
          "level": 3,
          "title": "Multiple Rows & Columns",
          "slug": "multiple-rows-columns"
        },
        {
          "level": 3,
          "title": "Responsive Layouts",
          "slug": "responsive-layouts"
        },
        {
          "level": 3,
          "title": "Screen Sizes",
          "slug": "screen-sizes"
        },
        {
          "level": 2,
          "title": "Working With Dates",
          "slug": "working-with-dates"
        },
        {
          "level": 3,
          "title": "Single Dates",
          "slug": "single-dates"
        },
        {
          "level": 3,
          "title": "Date Ranges",
          "slug": "date-ranges"
        },
        {
          "level": 3,
          "title": "Date Patterns",
          "slug": "date-patterns"
        },
        {
          "level": 3,
          "title": "Collections",
          "slug": "collections"
        },
        {
          "level": 3,
          "title": "Disabling Dates",
          "slug": "disabling-dates"
        },
        {
          "level": 3,
          "title": "Include vs Exclude Dates",
          "slug": "include-vs-exclude-dates"
        },
        {
          "level": 2,
          "title": "i18n",
          "slug": "i18n"
        },
        {
          "level": 3,
          "title": "Locales",
          "slug": "locales"
        },
        {
          "level": 3,
          "title": "Formatting & Parsing Dates",
          "slug": "formatting-parsing-dates"
        },
        {
          "level": 3,
          "title": "Mask Tokens",
          "slug": "mask-tokens"
        },
        {
          "level": 2,
          "title": "Installation",
          "slug": "installation"
        },
        {
          "level": 3,
          "title": "NPM",
          "slug": "npm"
        },
        {
          "level": 3,
          "title": "CDN",
          "slug": "cdn"
        },
        {
          "level": 2,
          "title": "Custom Defaults",
          "slug": "custom-defaults"
        }
      ]
    }
  ],
  "themeConfig": {
    "nav": [
      {
        "text": "My Demos",
        "link": "/mydemos/"
      },
      {
        "text": "Guide",
        "link": "/guide/"
      },
      {
        "text": "API",
        "link": "/api/"
      },
      {
        "text": "Changelog",
        "link": "/changelog/v1.0"
      }
    ],
    "sidebar": {
      "/guide/": [
        {
          "title": "Guide",
          "collapsable": false,
          "children": [
            "",
            "attributes",
            "datepicker",
            "theming-guide"
          ]
        }
      ],
      "/changelog/": [
        {
          "title": "Changelog",
          "collapsable": false,
          "children": [
            "v0.1",
            "v0.2",
            "v0.3",
            "v0.4",
            "v0.5",
            "v0.6",
            "v0.7",
            "v0.8",
            "v0.9",
            "v1.0"
          ]
        }
      ],
      "/api/": [
        {
          "title": "API",
          "collapsable": false,
          "children": [
            "",
            "defaults",
            "calendar",
            "page-object",
            "day-object",
            "attribute",
            "datepicker",
            "theme-styles",
            "date-patterns"
          ]
        }
      ],
      "/tests/": [
        {
          "title": "Tests",
          "children": [
            ""
          ]
        }
      ],
      "/showcase/": [
        {
          "title": "Showcase",
          "collapsable": false,
          "children": [
            "",
            "github"
          ]
        }
      ]
    },
    "repo": "nathanreyes/v-calendar",
    "docsDir": "docs",
    "docsBranch": "master",
    "editLinks": true,
    "editLinkText": "Help me improve this page!"
  }
}